// Spreadsheet recognition, deliberately not re-exported from the package root
// alongside the asset schemas that describe the same files: that barrel drags in
// every schema and about 240 kB of zod. This module is plain data and a
// predicate, so a caller that only needs to know whether a file is a spreadsheet
// leaves zod out of its bundle.

const SPREADSHEET_MIME_TYPES: ReadonlySet<string> = new Set([
  "text/csv",
  "application/csv",
  "text/comma-separated-values",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel.sheet.3",
  "application/vnd.ms-excel.sheet.2",
  "application/vnd.ms-excel.workspace.3",
  "application/vnd.ms-excel.workspace.4",
  "application/vnd.ms-excel.sheet.4",
  "application/vnd.ms-excel.sheet.macroenabled.12",
  "application/vnd.ms-excel.addin.macroenabled.12",
  "application/vnd.ms-excel.template.macroenabled.12",
]);

export const SPREADSHEET_MIME_TYPE_LIST: readonly string[] = [...SPREADSHEET_MIME_TYPES];

/** Covers assets whose stored MIME type is generic — an upload the browser could not type lands
 *  as application/octet-stream. */
const SPREADSHEET_FILE_EXTENSIONS: ReadonlySet<string> = new Set(["csv", "xls", "xlsx", "xlsm"]);

export const isSpreadsheetAsset = (asset: { mimeType?: string; filename?: string }): boolean => {
  if (asset.mimeType && SPREADSHEET_MIME_TYPES.has(asset.mimeType.toLowerCase())) return true;
  const extension = asset.filename?.split(".").pop()?.toLowerCase();
  return extension !== undefined && SPREADSHEET_FILE_EXTENSIONS.has(extension);
};
